<template>
    <v-container class="breadcrumbs">
        <v-layout align-center class="taxonomy guia" v-if="false">
            <v-flex>
                <h4>{{ guia }}</h4>
            </v-flex>
        </v-layout>
        <v-row dense class="titles" style="height:auto">
            <v-col cols="12">
                <h1>{{ titulo }}</h1>
            </v-col>
        </v-row>
        <v-row dense wrap class="titles">
            <v-col  v-if="tabs == undefined || tabs.length == 0" cols="12">
                <h4 style="padding-left:12px;" v-html="descricao"></h4>
            </v-col>            
            <v-col v-if="tabs != undefined && tabs.length > 0" cols="4">
                <h4 style="padding-left:1px;" v-html="descricao"></h4>
            </v-col>
            <v-col cols="8" v-if="tabs != undefined && tabs.length > 0" class="text-lg-right">
                <ul class="nav-main">
                    <li v-for="(item, index) in tabs" :key="index">
                        <a href="#" :class="selectedTab == item.id ? 'active' : ''" @click="selectTab(item.id)">{{item.titulo}}</a>
                    </li>
                </ul>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "corretor-breadcrumbs",
    props: ["guia", "titulo", "descricao", "tabs"],
    data() {
        return {
            selectedTab: 1
        }
    },
    methods: {
        selectTab(value){
            this.selectedTab = value;
            this.$emit("selectTab", value);
        }
    },
}
</script>

<style lang="scss">
.breadcrumbs{
    height: var(--breadcrumbs-height);
    flex: none;
    background-color: var(--background);
    padding-top: 10px;
}

.breadcrumbs h4:first-child{
    margin-top: 3px;
    color: var(--grey-dark);
}
.breadcrumbs .guia{
    height: 30px;
}
.taxonomy, .titles{
    padding: 0 var(--gutter) 0 var(--gutter);
    height: var(--breadcrumbs-content-height);
}
.nav-main{
    list-style-type: none;
    margin-top: 8px;
    li{
            display: inline-block;
        a{
            padding:2px 20px;
            color: #9b9b9b;
            text-decoration: none;
            font-size: 12px;
            &:hover{
                border-bottom: 2px solid var(--blue-light)
            }
            &.active{
                color: var(--blue-light);
                border-bottom: 2px solid var(--blue-light)
            }                
        }
    }
}
</style>
